module.exports = __webpack_public_path__ + "img/25.b07c560b.webp";